import { KeyValue, KeyValuePipe, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { MessageType } from 'enums/MessageType';
import { ReasonModel } from 'models/generated/Entities.GormCrm.Reason';
import { ReasonCategoryModel } from 'models/generated/Entities.GormCrm.ReasonCategory';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { LanguageService } from 'services/language.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';
import { PushService } from 'services/push.service';
import { ReasonService } from 'services/reason.service';
import { ListReasonCategoriesComponent } from './list-reason-categories.component';
import { ViewReasonComponent } from './view-reason.component';

@Component({
	selector: 'list-reasons',
	templateUrl: './list-reasons.component.html',
	imports: [Layout, ListView, NgTemplateOutlet, ViewReasonComponent, KeyValuePipe, TranslatePipe]
})
@ComponentUrl('list-reasons')
@CredentialRequired(CredentialType.EditReasons)
export class ListReasonsComponent {

	reasons?: ReasonModel[];
	reasonCategories?: ReasonCategoryModel[];
	selectedReason?: ReasonModel;
	selectedReasonCategory?: ReasonCategoryModel;
	onReasonChanges: Subscription;
	onReasonCategoryChanges: Subscription;
	public reasonsByKey = new Map<string, ReasonModel[]>();

	constructor(private readonly pushService: PushService,
		private readonly navigation: NavigationService,
		private readonly reasonService: ReasonService,
		private readonly notificationService: NotificationService,
		private readonly languageService: LanguageService) {

		this.updateReasonsList();

		this.onReasonChanges = this.pushService.onChanges(MessageType.ReasonChanges).subscribe(_ => this.updateReasonsList());
		this.onReasonCategoryChanges = this.pushService.onChanges(MessageType.ReasonCategoryChanges).subscribe(_ => this.updateReasonsList());
	}

	updateReasonsList() {
		this.reasonService.getAllReasons().then((tr) => {
			this.reasons = tr;
			this.splitReasonByCategory();
		});
		this.reasonService.getAllReasonCategories().then((trc) => {
			this.reasonCategories = trc.sort((a, b) => a.name.localeCompare(b.name, this.languageService.isoCode))
			this.splitReasonByCategory();
		});
	}

	splitReasonByCategory() {
		if (!this.reasonCategories || !this.reasons) return;

		this.reasonsByKey = new Map<string, ReasonModel[]>();
		let categories = [undefined, ...this.reasonCategories.map(trc => trc.id)];
		categories.forEach(category => this.reasonsByKey.set(category!, this.reasons!.filter(tr => tr.categoryId === category)));
	}

	getCategoryName(id: string) {
		let name = this.reasonCategories?.find(trc => trc.id == id)?.name;
		return name ? name : 'n/a';
	}

	deleteReason(reason: ReasonModel) {
		this.notificationService.confirm('reason.prompt-for-delete', { 'reasonName': reason.name }).subscribe(result => {
			if (result)
				this.reasonService.deleteReason(reason.id!).then(_ => this.selectedReason = undefined);
		});
	}

	createReasonCategory() {
		this.selectedReason = undefined;
		this.navigation.openPopup(ListReasonCategoriesComponent, 'reason.create-new-category-popup.header');
	}

	createNewReason() {
		this.selectedReason = new ReasonModel();
	}

	ngOnDestroy() {
		this.onReasonChanges.unsubscribe();
		this.onReasonCategoryChanges.unsubscribe();
	}

	// Maintains the original order of map object for keyvalue pipe
	originalOrder = (a: KeyValue<string, ReasonModel[]>, b: KeyValue<string, ReasonModel[]>): number => 0;
}
